class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this))
    
    // Toggle check on all the checkbox labels to display the active values
    facetForm.addEventListener('input', (event) => {
      // For the "sort by" as it's a radio, remove checked on all choices before putting it on the one we want
      if(event.target.name == 'sort_by') {
        document.querySelectorAll(`[data-radio-sort]`).forEach((label) => {
          label.classList.remove('checked')
        })

        document.querySelector('[data-sort-by-displayed]').innerHTML = event.target.parentElement.querySelector('label').innerHTML
      } else {
        // Get changed filter number of current values
        let inputs = document.querySelectorAll(`[name='${event.target.getAttribute('name')}']`)
        let numberOfActiveFilters = Object.values(inputs).filter((input) => input.checked).length;

        // If number is more than 0, place it as a sup to the filter title, if not hide it
        let targetedAttribute = event.target.getAttribute('name')
        document.querySelectorAll(`[data-filter-sup="${targetedAttribute}"]`).forEach((displayedNumber) => {
          if(numberOfActiveFilters == 0) {
            displayedNumber.classList.add('u-hidden')
          } else {
            displayedNumber.innerHTML = numberOfActiveFilters;
            displayedNumber.classList.remove('u-hidden')
          } 
        })
      }

      this.displayMobileInlineFiltersContent();

      document.querySelectorAll(`[for="${event.target.id}"]`).forEach((label) => {
        label.classList.toggle('checked')
      });
    });

    document.body.addEventListener('filterPriceChanged', () => {
      this.displayMobileInlineFiltersContent();
    })

  }

  displayMobileInlineFiltersContent() {
    // Get how many filters are active: for each checked input, add 1 to count (unless if it's the 'sort_by', as we can't delete it)
    let numberActiveFilters = 0
    this.querySelectorAll("input:checked").forEach((input) => {
      if(input.name != 'sort_by') numberActiveFilters++
    })
    let totalDisplayed = document.querySelector('[data-total-filters]')
    let inlineRemoveFilters = document.querySelector('[data-inline-remove-filters]');

    // If price filter is set, add 1 to filter count
    if(totalDisplayed.getAttribute('data-price-active') == "true") numberActiveFilters ++

    if(numberActiveFilters > 0) {
      // Display the number of current active filters :
      totalDisplayed.classList.remove('u-hidden')
      totalDisplayed.innerHTML = numberActiveFilters

      // Display the CTA to remove all filters
      inlineRemoveFilters.classList.remove('u-hidden')
    } else {
      totalDisplayed.classList.add('u-hidden')
      inlineRemoveFilters.classList.add('u-hidden')
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('[data-facets-remove]').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    let container = document.querySelector('[data-facets-products-grid]')
    container.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-facets-products-grid]').innerHTML;

    document.dispatchEvent(new CustomEvent('product:card-rerender', { detail: { container: container }   }));
    document.dispatchEvent(new CustomEvent('clrz-slider-card-product:rerender', { detail : { container: container } }));
    document.dispatchEvent(new CustomEvent('revive:stand-by', { detail : { container: container } }));

  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-facets-count]').innerHTML
    const container = document.querySelector('[data-facets-count]');
    container.innerHTML = count;
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.querySelector('[data-facets-product-grid]').dataset.id,      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      const forms = [];


      sortFilterForms.forEach((form) => {
          if (form.id === 'FacetFiltersForm') {
            forms.push(this.createSearchParams(form));
          }
      });
      this.onSubmitForm(forms.join('&'), event)
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
      super();
      this.querySelectorAll('input[type="range"]')
          .forEach(element => element.addEventListener('input', this.onRangeChange.bind(this)));
      this.setMinAndMaxValues();
      
  }

  onRangeChange(event) {
      const minInput = this.querySelector('input[name="filter.v.price.gte"]');
      const maxInput = this.querySelector('input[name="filter.v.price.lte"]');

      // Limiter la plage de prix à 10€
      const min = parseFloat(minInput.value);
      const max = parseFloat(maxInput.value);
      const diffMinMax = 10
      if (max - min < diffMinMax) {
          if (event.currentTarget === minInput) {
              maxInput.value = min + diffMinMax;
          } else {
              minInput.value = max - diffMinMax;
          }
      }
      
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const minActiveValueElement = this.querySelector('[data-min-active-value]');
    const maxActiveValueElement = this.querySelector('[data-max-active-value]');
    const inputs = this.querySelectorAll('input[type="range"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    const currentCurrency = minInput.dataset.currency;

      if (minInput.value) minActiveValueElement.textContent = `${minInput.value}${currentCurrency}`;
      if (maxInput.value)  maxActiveValueElement.textContent = `${maxInput.value}${currentCurrency}`;
  }

  adjustToValidValues(input) {
      const value = parseFloat(input.value);
      const min = parseFloat(input.getAttribute('min'));
      const max = parseFloat(input.getAttribute('max'));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this)); 
    facetLink.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
